export interface HoursAndMinutes {
  h: number;
  m: number;
  s: number;
}

export class DurationUtils {
  /**
   * Splits a number of seconds into hours, minutes and seconds.
   *
   * All three come back as NUMBERS. The minutes used to be padded here, which
   * meant the function returned a string for nine minutes out of sixty and a
   * number for the rest, and the cast that hid it also hid where it landed:
   * edit-duration patches a numeric form control with what this returns, so a
   * duration of one hour and five minutes filled that control with "05".
   *
   * Padding is a display concern and now belongs to the pipe that displays it.
   */
  static toHoursAndMinutes(totalSeconds: number): HoursAndMinutes {
    const totalMinutes = Math.floor(totalSeconds / 60);

    return {
      h: Math.floor(totalMinutes / 60),
      m: totalMinutes % 60,
      s: totalSeconds % 60,
    };
  }
}
